import PropTypes from 'prop-types';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import styles from './round-button.module.less';

const RoundButton = (props) => {
    const onClick = (e) => {
        if (props.onClick) {
            e.preventDefault();
            if (props.trackingCategory && props.trackingAction) {
                trackEvent(props.trackingCategory, props.trackingAction, props.trackingParameters);
            }

            return props.onClick();
        }
    };

    return (
        <button
            onClick={onClick}
            title={props.alt}
            className={`${styles.roundButton} ${props.className}`}
            aria-label={props.ariaLabel}
        >
            {props.children}
        </button>
    );
};

RoundButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    alt: PropTypes.string,
    trackingCategory: PropTypes.string,
    trackingAction: PropTypes.string,
    trackingParameters: PropTypes.string,
    children: PropTypes.node,
};

RoundButton.defaultProps = {
    className: '',
    alt: '',
    action: '',
    category: '',
    children: null,
};

export default RoundButton;
